// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2407":"09104f104b66627b","16497":"3e5d36fe3ea0734c","29246":"fde45b7613fcfbbc","37471":"930982dbdd4e04e8","74749":"17d2ede36b187547","94522":"efe296f01c250ab8"}[chunkId] + ".css";
};